<template>
  <v-card
    class="app-card app-card--without-border app-card--without-margin-bottom"
  >
    <v-card-title class="app-card-title" primary-title>
      Excluir Autorização
    </v-card-title>
    <v-card-text class="app-card-content">
      <p>
        Deseja excluir mesmo essa Autorização
        <strong
          >{{ autorizacao.numeroLicenca }} -
          {{ autorizacao.tipoLiceca }}</strong
        >
        ?
      </p>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="app-card-actions">
      <v-btn depressed color="error" type="button" @click="closeDialog"
        >Cancelar</v-btn
      >
      <v-btn
        depressed
        color="#3eb355"
        class="white--text"
        @click="confirmDelete"
      >
        Confirmar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import LicencaEspecialService from "@/services/licencaEspecial.service";

export default {
  name: "AutorizacaoDeleteDialog",
  props: { autorizacao: Object },
  data() {
    return {};
  },
  methods: {
    confirmDelete() {
      if (this.autorizacao) {
        LicencaEspecialService.removerAutorizacaoFretamento(
          this.autorizacao
        ).subscribe(
          res => {
            this.closeDialog({
              type: "success",
              message: "Autorização excluida com sucesso!"
            });
          },
          error => {
            //console.log(error);
          }
        );
      }
    },
    closeDialog(event = { type: "close", message: "" }) {
      this.$emit("closeDialog", event);
    }
  }
};
</script>

<style></style>
